import axios from "axios";
import api from "./api";

const ADMIN_TOKEN_KEY = "ticketwhats-admin:token";
const ADMIN_USER_KEY = "ticketwhats-admin:user";

export const signIn = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
};

export const refreshAdminToken = async () => {
  const response = await api.post("/auth/refresh_token", null, {
    headers: {
      "X-Client-App": "admin"
    }
  });
  return response.data;
};

export const validateSession = async () => {
  const token = typeof window !== "undefined" ? localStorage.getItem(ADMIN_TOKEN_KEY) : null;

  if (!token) {
    throw new Error("NO_TOKEN");
  }

  const validateApi = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8080",
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Client-App": "admin"
    }
  });

  const { data } = await validateApi.get("/admin/v1/me/profile");
  return data;
};
